export default __webpack_public_path__ + "1f14907b917b2eff3b9d742defd6ac87.png";